module.exports = __webpack_public_path__ + "img/chatgpt.df18d00b.svg";